export default "__VITE_ASSET__BvKJazwa__"